import React, { FC } from "react";
import { usePurchaseRoDetailsModel } from "./purchaseRoDetailsModel";
import { YHDrawer } from "@/components/YhDrawer";
import { ColumnsType } from "antd/lib/table";
import { Table } from "antd";
import { RouterParamType } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { debounce } from "lodash";

export const WhConfirmDrawer: FC<RouterParamType> = ({ id, mode }) => {
    const { wsConfirmModal: visible, detailDataSource, detailLookList, setWsConfirmModal, warehousing, getDetailEditOne } = usePurchaseRoDetailsModel();

    const onCancel = () => {
        setWsConfirmModal(false);
    };
    const onSubmit = async () => {
        let retData = await warehousing()
        if (retData) {
            await onCancel();
            await getDetailEditOne(id, mode);
            await globalPrompt("message", { text: "出库成功", type: "success" });

        } else {
            await onCancel()
            await globalPrompt("message", { text: "出库失败", type: "error" });
        }
    }

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            dataIndex: "index",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        },
        {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
        }, {
            title: '配件名称',
            width: 160,
            dataIndex: 'materialName',
        }, {
            title: '出库数量',
            width: 160,
            dataIndex: 'num',
        }
    ];
    return (
        <YHDrawer
            {...{
                title: '库房确认',
                visible,
                onCancel,
                width: 800,
                okText: "保存",
                onOk: onSubmit,
                // onOk:()=>debounce(() => { onSubmit() }, 900),
                showFooter: mode === "look" ? false : true

            }}
        >
            <Table
                bordered
                // size="small"
                rowKey={record => record.id}
                columns={columns}
                dataSource={mode == "edit" ? detailDataSource : detailLookList}
                pagination={false}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 400 }}
            />
        </YHDrawer>
    )
}